// Import statements
import React from 'react';
import { Link } from "react-router-dom";
import Logo from '../images/vanani_logo.svg';

// Component definition
const Footer = () => {
  return (
    <div className='footer-wrapper'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-4'>
            <div className='first_logo_text'>
              <img src={Logo} alt="Vanani Assosiated" />
              <p>At Vanani & Associates, we provide comprehensive financial and advisory services tailored to
                businesses of all sizes. Our team of experienced experts offers deep industry knowledge,
                ensuring personalized and ethical service. We are dedicated to driving growth and success
                for our clients through innovative solutions and unwavering commitment.</p>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='link_list'>
              <h5>Important Links</h5>
              <ul className='important_links'>
                <li><Link to='/accounting'>Accounting</Link></li>
                <li><Link to='/taxation'>Taxation</Link></li>
                <li><Link to='/coming-soon'>Corporate Compliance</Link></li>
                <li><Link to='/coming-soon'>CFO Services</Link></li>
                <li><Link to='/audit-and-assurance-services'>Audit & Assurance</Link></li>
                <li><Link to='/coming-soon'>Tax Litigation</Link></li>
                <li><Link to='/coming-soon'>Management Consultancy</Link></li>
                <li><Link to='/coming-soon'>Knowledge Process Outsourcing</Link></li>
              </ul>
            </div>
          </div>

          <div className='col-md-2'>
            <div className='link_list'>
              <h5>Quick Links</h5>
              <ul>
                <li><Link to='/'>Home</Link></li>
                <li><Link to='/about'>About Us</Link></li>
                <li><Link to='/services'>Services</Link></li>
                <li><Link to='/coming-soon'>Industries</Link></li>
                <li><Link to='/coming-soon'>Careers</Link></li>
                <li><Link to='/coming-soon'>Knowledge Bank</Link></li>
                <li><Link to='/blogs'>Blog</Link></li>
                <li><Link to='/coming-soon'>Query</Link></li>
                <li><Link to='/contact-us'>Contact Us</Link></li>
              </ul>
            </div>
          </div>

          <div className='col-md-3'>
            <div className='link_list'>
              <h5>Corporate Profile</h5>
              <div className='ft_img_wrap'>
                <img src='/images/footer_books.jpg'></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Export the component
export default Footer;
